import React, { Fragment, useEffect, useState } from 'react'
import ModalWrapper from '../../common/Modal/ModalWrapper'
import TrashIcon from '@rsuite/icons/Trash';
import { useDispatch, useSelector } from 'react-redux';
import { toggleModal } from '../../../reducers/modalReducer';
import { Divider } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';
import Button from '../../common/Button';

const UnallocatedFilesModal = ({ company, tab, onClickUnallocatedBinAuditLog, unallocatedFiles, modalType, handleEditDispatch, setDeleteUnallocatedFile, loading, moveUnallocatedFile, setUnallocatedFiles }) => {

    const dispatch = useDispatch()
    const { rModalData } = useSelector(state => state.fileAllocation)
    const [aiPopover, setAiPopover] = useState(null);

    useEffect(() => {
        if (rModalData.newQNo) {
            const data = [...unallocatedFiles].reduce((acc, cur) => {
                if (cur.id === rModalData.fileData.id) {
                    acc.push({
                        ...cur,
                        "sectionNo": rModalData.newQNo,
                        "name": rModalData.newQName
                    })
                } else {
                    acc.push({ ...cur })
                }
                return acc
            }, [])
            return console.log(data, "data after reallocation")
            // moveUnallocatedFile({

            //         })
            // moveUnallocatedFile(rModalData.fileData, true, rModalData.newQNo, rModalData.newQName)
            dispatch(setUnallocatedFiles(data))
        }

    }, [rModalData])

    const onClickReallocationComplete = async () => {
        const unallocate = unallocatedFiles.filter((un) => un.sectionNo)
        moveUnallocatedFile({ payload: unallocate })
        console.log(unallocate, "unallocatedFiles after reallocation complete")
    }

    const getUnallocatedFileHTML = (unallocatedFile, index) => {
        const file = unallocatedFile.file;
        const fileUrl = file.location;
        const title = file.originalname;
        const key = file.key;
        const reasoning = unallocatedFile.reasoning || '';
        const suggestedQNo = unallocatedFile.suggestedQNo || '';
        const suggestedSection = unallocatedFile.suggestedSection || '';
        const suggestedQuestion = unallocatedFile.suggestedQuestion || '';
        let module = company.modules[tab];
        if (module) module = JSON.parse(JSON.stringify(module));
        return <Fragment key={`unallocateFile-${index}`}>
            <tr>
                <td className={"fs1rem fw600 bg1"} style={{ overflow: 'hidden', maxWidth: 0 }}>
                    <div
                        onClick={() => getViewableURL(fileUrl)}
                        className={`tal fs14px fw600 tdu bg1 lightDot red`}
                        style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', paddingLeft: '0.5rem' }}
                        data-tooltip={title}
                    >
                        {title}
                    </div>
                </td>
                <td className="frs-td mx1rem fs1rem fw600 bg1">
                    <div className="df fdr aic jcfs">
                        <div className="rs-nav rs-nav-default">
                            <div
                                onClick={() =>
                                    handleEditDispatch({ key: key, fileName: title, from: "unallocated", actionType: "reallocate", fileData: unallocatedFile, index, module })
                                }
                                className="bg62 br10px fw400 fs13px df aic p0-5rem jcsb c49 fsi cp">
                                {(unallocatedFile.sectionNo && `${unallocatedFile.sectionNo}. ${unallocatedFile['name']}`) || 'Please select section'}
                                <KeyboardArrowDown className='c3' />
                            </div>
                        </div>
                    </div>
                </td>

                <td className="frs-td fs1rem fw600 bg1">
                    <div className="df fdr aic jcc" style={{ gap: '0.5rem' }}>
                        {(reasoning || suggestedQNo) && (
                            <span
                                onMouseEnter={e => { const r = e.currentTarget.getBoundingClientRect(); setAiPopover(p => p?.pinned ? p : { reasoning, suggestedQNo, suggestedSection, suggestedQuestion, fileName: title, x: r.left, y: r.bottom, pinned: false }); }}
                                onMouseLeave={() => setAiPopover(p => p?.pinned ? p : null)}
                                onClick={e => { e.stopPropagation(); const r = e.currentTarget.getBoundingClientRect(); setAiPopover(p => p?.pinned ? null : { reasoning, suggestedQNo, suggestedSection, suggestedQuestion, fileName: title, x: r.left, y: r.bottom, pinned: true }); }}
                                style={{ display: 'inline-flex', alignItems: 'center', gap: '3px', background: '#dc262618', border: '1px solid #dc262640', borderRadius: '12px', padding: '3px 8px', cursor: 'pointer', flexShrink: 0 }}
                            >
                                <img src={require('../../../../images/intelligentiaIcon.png')} alt="icon" className="w20px h20px mr0-5rem" />
                            </span>
                        )}
                        <TrashIcon data-tooltip={"Delete"} onClick={e => {
                            e.preventDefault();
                            setDeleteUnallocatedFile(unallocatedFile);
                            dispatch(toggleModal({ open: 'deleteUnallocatedFile', from: 'unallocated' }))
                        }}
                            className="cp f9 h1rem"
                        />
                    </div>
                </td>
            </tr>
        </Fragment>
    };

    return (
        <>
            <ModalWrapper
                modalType={modalType}
                modalCardClasses="maw1200px mah80 p2rem"
            >
                <div className='df jcsb pr'>
                    <div className='df jcfs aic'>
                        <img src={require("../../../../images/dataRepo/file.svg")} alt={"fileManagement"} />
                        <h1 className="c15 fw600 fs20px mb0rem ml0-5rem">Unallocated Files Bin</h1>
                    </div>

                    <button
                        onClick={onClickUnallocatedBinAuditLog}
                        className='cp tac c1 bg5 c15 br20px px1-5rem py0-5rem fw500'>
                        Log
                    </button>
                </div>

                <Divider style={{ marginTop: "16px", marginBottom: "16px" }} />

                <div className="dg gg0-5rem mb2rem fs1rem mah300px oya" >
                    <table className="fis bcc" style={{ tableLayout: 'fixed', width: '100%' }}>
                        <thead>
                            <tr>
                                <th className="w50 tal fs14px fw400 c37" style={{ width: '55%' }}>Unallocated File</th>
                                <th className="w40 tal fs14px fw400 c37" style={{ width: '35%' }}>Allocation Section</th>
                                <th className="w10 fs14px fw400 c37" style={{ width: '10%' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {unallocatedFiles && unallocatedFiles.length > 0 && unallocatedFiles.map(getUnallocatedFileHTML)}
                        </tbody>
                    </table>
                    {unallocatedFiles && unallocatedFiles.length == 0 ? (
                        <div className='df fdc jcc aic m2rem'>
                            <img src={require("../../../../images/dataRepo/empty-inbox.svg")} alt={"fileManagement"} />
                            <p className="fs1rem fw600 mt1rem tac c15 op80">No files found</p>
                        </div>
                    ) : null}
                </div>
                {
                    unallocatedFiles.filter((un) => un.sectionNo).length ? <div className="df w100 fdr jcc mt2rem">
                        <Button
                            onClick={onClickReallocationComplete}
                            text={"Confirm Allocation"}
                            disabled={loading}
                            btnType='warning'
                            customClassName="maw300px"
                        />
                    </div> : null
                }

            </ModalWrapper>

            {/* AI Reasoning Popover */}
            {aiPopover && (
                <div onClick={() => { if (aiPopover.pinned) setAiPopover(null); }} style={{ position: 'fixed', inset: 0, zIndex: 9999, pointerEvents: aiPopover.pinned ? 'auto' : 'none' }}>
                    <div
                        onClick={e => e.stopPropagation()}
                        style={{ position: 'fixed', top: Math.max(8, aiPopover.y - 280), left: Math.min(Math.max(aiPopover.x - 260, 8), window.innerWidth - 296), width: '280px', background: '#fff', borderRadius: '12px', boxShadow: '0 8px 32px rgba(0,0,0,0.15)', padding: '1rem', zIndex: 10000, border: '1px solid #E5E7EB' }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <img src={require('../../../../images/intelligentiaIcon.png')} alt="icon" className="w20px h20px mr0-5rem" />
                                <span style={{ fontWeight: 700, fontSize: '13px', color: '#111827' }}>Why Unallocated?</span>
                            </div>
                            <span onClick={() => setAiPopover(null)} style={{ cursor: 'pointer', color: '#9CA3AF', fontSize: '14px', lineHeight: 1 }}>✕</span>
                        </div>
                        <div style={{ height: '1px', background: '#F3F4F6', marginBottom: '0.75rem' }} />
                        <div>
                            <p style={{ fontSize: '11px', fontWeight: 600, color: '#6B7280', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>AI Reasoning</p>
                            <p style={{ fontSize: '12px', color: '#374151', lineHeight: 1.5, margin: aiPopover.suggestedQNo ? '0 0 8px' : 0 }}>
                                {aiPopover.fileName && <span style={{ fontWeight: 700, wordBreak: 'break-all' }}>{aiPopover.fileName}</span>}
                                {aiPopover.fileName && ' - '}
                                {aiPopover.reasoning || 'Confidence too low to allocate automatically.'}
                            </p>
                            {aiPopover.suggestedQNo && (
                                <div style={{ background: '#EFF6FF', border: '1px solid #BFDBFE', borderRadius: '7px', padding: '6px 10px' }}>
                                    <p style={{ fontSize: '11px', fontWeight: 600, color: '#1D4ED8', marginBottom: '2px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Possible match</p>
                                    <p style={{ fontSize: '12px', color: '#1E40AF', lineHeight: 1.5, margin: 0 }}>
                                        {aiPopover.suggestedQNo}{aiPopover.suggestedSection ? ' — ' + aiPopover.suggestedSection : ''}{aiPopover.suggestedQuestion ? ': ' + aiPopover.suggestedQuestion : ''}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default UnallocatedFilesModal